import React, { useEffect, useState } from 'react';
import { LoginStyled } from './Login-styles';
import _ from 'lodash';
import { AppButton } from '../../components/AppButton/AppButton';
import { API_CODE, SOURCE, TARGET } from '../../common/utils/const';
import { authServ } from '../../services';
import { getLocalstorage, setLocalstorage } from '../../common/utils/other';

export default function Login() {
	const search = window.location.search;
	const params = new URLSearchParams(search);
	let source = params.get(TARGET);
	if (!source) {
		setLocalstorage(TARGET, SOURCE.PPRS);
	}

	const handle_Login = async () => {
		try {
			const { data, errCode } = await authServ.signin();

			if (errCode == API_CODE.SUCCESS) {
				window.location.href = data?.url_signin;
			}
		} catch (error) {
		}
	};

	/**
	 * renders
	 */
	return (
		<LoginStyled>
			<div className="login-page">
				<div className="content">
					<div className="content-1">
						<h1>
							{/* THE <span>GEAR</span> */}
							<img src="kajima_logo_1.png" height={40} />
						</h1>
						<h3>
							KAJIMA
						</h3>
						<img
							className="image-login"
							src="image_login_content.svg"
						/>
						<h3>STAFF PREFERENCE</h3>
						<h3>REGISTRATION SYSTEM</h3>
						<AppButton label="LOGIN" onClick={handle_Login} />
						<span>
							Need help?{' '}
							<a href="mailto:helpdesk@kajimathegear.sg">
								Contact Support
							</a>
						</span>
					</div>
				</div>
			</div>
		</LoginStyled>
	);
}
